export const getRandomInt = (max) => {
  return Math.floor(Math.random() * Math.floor(max))
}

export const getRandomFromObject = (obj) => {
  const keys = Object.keys(obj)
  const key = keys[getRandomInt(keys.length)]
  return key
}

export const getRandomFromArray = (arry) => {
  return arry[getRandomInt(arry.length)]
}

const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'.split('')

export const randomSlug = (length) => {
  let slug = ''
  for (let i = 0; i < length; i++) {
    slug = slug + getRandomFromArray(chars)
  }

  return slug
}
